import AllieJpg from './allie/allie.jpg';
import AllieWebp from './allie/allie.webp';

import BlinkyJpg from './blinky/blinky.jpg';
import BlinkyWebp from './blinky/blinky.webp';

import BrunoJpg from './bruno/bruno.jpg';
import BrunoWebp from './bruno/bruno.webp';

import BrunoBulldog from './bruno-bulldog/bruno-bulldog.jpg';
import BrunoBulldogWebp from './bruno-bulldog/bruno-bulldog.webp';

import BuzzJpg from './buzz/buzz.jpg';
import BuzzWebp from './buzz/buzz.webp';

import CaptainJpg from './captain/captain.jpg';
import CaptainWebp from './captain/captain.webp';

import ChoochJpg from './chooch/chooch.jpg';
import ChoochWebp from './chooch/chooch.webp';

import CrosbyJpg from './crosby/crosby.jpg';
import CrosbyWebp from './crosby/crosby.webp';

import DesiDaphneHamishJpg from './desi-daphne-hamish/desi-daphne-hamish.jpg';
import DesiDaphneHamishWebp from './desi-daphne-hamish/desi-daphne-hamish.webp';

import EmmaJpg from './emma/emma.jpg';
import EmmaWebp from './emma/emma.webp';

import EvaAndEffieJpg from './eva-and-effie/eva-and-effie.jpg';
import EvaAndEffieWebp from './eva-and-effie/eva-and-effie.webp';

import FranciscoJpg from './francisco/francisco.jpg';
import FranciscoWebp from './francisco/francisco.webp';

import GiovanniJpg from './giovanni/giovanni.jpg';
import GiovanniWebp from './giovanni/giovanni.webp';

import KoliJpg from './koli/koli.jpg';
import KoliWebp from './koli/koli.webp';

import LegendChubbsJpg from './legend-chubbs/legend-chubbs.jpg';
import LegendChubbsWebp from './legend-chubbs/legend-chubbs.webp';

import LucyJpg from './lucy/lucy.jpg';
import LucyWebp from './lucy/lucy.webp';

import MjJpg from './mj/mj.jpg';
import MjWebp from './mj/mj.webp';

import OllieJpg from './ollie/ollie.jpg';
import OllieWebp from './ollie/ollie.webp';

import PickleJpg from './pickle/pickle.jpg';
import PickleWebp from './pickle/pickle.webp';

import PiperJpg from './piper/piper.jpg';
import PiperWebp from './piper/piper.webp';

import RemiJpg from './remi/remi.jpg';
import RemiWebp from './remi/remi.webp';

import RosieJpg from './rosie/rosie.jpg';
import RosieWebp from './rosie/rosie.webp';

import SadieJpg from './sadie/sadie.jpg';
import SadieWebp from './sadie/sadie.webp';

import SaidiDeanJpg from './saidi-dean/saidi-dean.jpg';
import SaidiDeanWebp from './saidi-dean/saidi-dean.webp';

import FranklinSingleJpg from './franklin-single/franklin-single.jpg';
import FranklinSingleWebp from './franklin-single/franklin-single.webp';

import SilverRayJpg from './silver-ray/silver-ray.jpg';
import SilverRayWebp from './silver-ray/silver-ray.webp';

import ThorJpg from './thor/thor.jpg';
import ThorWebp from './thor/thor.webp';

import TobeyJpg from './tobey/tobey.jpg';
import TobeyWebp from './tobey/tobey.webp';

import ValiJpg from './vali/vali.jpg';
import ValiWebp from './vali/vali.webp';

import WinnieJpg from './winnie/winnie.jpg';
import WinnieWebp from './winnie/winnie.webp';

import ZeusJpg from './zeus/zeus.jpg';
import ZeusWebp from './zeus/zeus.webp';

import ZoeJpg from './zoe/zoe.jpg';
import ZoeWebp from './zoe/zoe.webp';

import PorkchopAfterJpg from './porkchop/porkchop-after.jpg';
import PorkchopAfterWebp from './porkchop/porkchop-after.webp';
import PorkchopBeforeJpg from './porkchop/porkchop-before.jpg';
import PorkchopBeforeWebp from './porkchop/porkchop-before.webp';

import HankAfterJpg from './hank/hank-after.jpg';
import HankAfterWebp from './hank/hank-after.webp';
import HankBeforeJpg from './hank/hank-before.jpg';
import HankBeforeWebp from './hank/hank-before.webp';

import DiegoAfterJpg from './diego/diego-after.jpg';
import DiegoAfterWebp from './diego/diego-after.webp';
import DiegoBeforeJpg from './diego/diego-before.jpg';
import DiegoBeforeWebp from './diego/diego-before.webp';

import BrodyAfterJpg from './brody/brody-after.jpg';
import BrodyAfterWebp from './brody/brody-after.webp';
import BrodyBeforeJpg from './brody/brody-before.jpg';
import BrodyBeforeWebp from './brody/brody-before.webp';

import KairoAfterJpg from './kairo/kairo-after.jpg';
import KairoAfterWebp from './kairo/kairo-after.webp';
import KairoBeforeJpg from './kairo/kairo-before.jpg';
import KairoBeforeWebp from './kairo/kairo-before.webp';

import MarloAfterJpg from './marlo/marlo-after.jpg';
import MarloAfterWebp from './marlo/marlo-after.webp';
import MarloBeforeJpg from './marlo/marlo-before.jpg';
import MarloBeforeWebp from './marlo/marlo-before.webp';

import FranklinAfterJpg from './franklin/franklin-after.jpg';
import FranklinAfterWebp from './franklin/franklin-after.webp';
import FranklinBeforeJpg from './franklin/franklin-before.jpg';
import FranklinBeforeWebp from './franklin/franklin-before.webp';

import MaryJaneAfterJpg from './mary-jane/mary-jane-after.jpg';
import MaryJaneAfterWebp from './mary-jane/mary-jane-after.webp';
import MaryJaneBeforeJpg from './mary-jane/mary-jane-before.jpg';
import MaryJaneBeforeWebp from './mary-jane/mary-jane-before.webp';

import NillaAfterJpg from './nilla/nilla-after.jpg';
import NillaAfterWebp from './nilla/nilla-after.webp';
import NillaBeforeJpg from './nilla/nilla-before.jpg';
import NillaBeforeWebp from './nilla/nilla-before.webp';

export const NillaAfterSources = [NillaAfterJpg, NillaAfterWebp];
export const NillaBeforeSources = [NillaBeforeJpg, NillaBeforeWebp];

export const MaryJaneAfterSources = [MaryJaneAfterJpg, MaryJaneAfterWebp];
export const MaryJaneBeforeSources = [MaryJaneBeforeJpg, MaryJaneBeforeWebp];

export const FranklinAfterSources = [FranklinAfterJpg, FranklinAfterWebp];
export const FranklinBeforeSources = [FranklinBeforeJpg, FranklinBeforeWebp];

export const MarloAfterSources = [MarloAfterJpg, MarloAfterWebp];
export const MarloBeforeSources = [MarloBeforeJpg, MarloBeforeWebp];

export const KairoAfterSources = [KairoAfterJpg, KairoAfterWebp];
export const KairoBeforeSources = [KairoBeforeJpg, KairoBeforeWebp];

export const PorkchopAfterSources = [PorkchopAfterJpg, PorkchopAfterWebp];
export const PorkchopBeforeSources = [PorkchopBeforeJpg, PorkchopBeforeWebp];

export const HankAfterSources = [HankAfterJpg, HankAfterWebp];
export const HankBeforeSources = [HankBeforeJpg, HankBeforeWebp];

export const DiegoAfterSources = [DiegoAfterJpg, DiegoAfterWebp];
export const DiegoBeforeSources = [DiegoBeforeJpg, DiegoBeforeWebp];

export const BrodyAfterSources = [BrodyAfterJpg, BrodyAfterWebp];
export const BrodyBeforeSources = [BrodyBeforeJpg, BrodyBeforeWebp];

export const AllieSources = [AllieJpg, AllieWebp];

export const BlinkySources = [BlinkyJpg, BlinkyWebp];

export const BrunoSources = [BrunoJpg, BrunoWebp];

export const BrunoBulldogSources = [BrunoBulldog, BrunoBulldogWebp];

export const BuzzSources = [BuzzJpg, BuzzWebp];

export const CrosbySources = [CrosbyJpg, CrosbyWebp];

export const DesiDaphneHamishSources = [
  DesiDaphneHamishJpg,
  DesiDaphneHamishWebp,
];

export const ChoochSources = [ChoochJpg, ChoochWebp];

export const CaptainSources = [CaptainJpg, CaptainWebp];

export const EmmaSources = [EmmaJpg, EmmaWebp];

export const EvaAndEffieSources = [EvaAndEffieJpg, EvaAndEffieWebp];

export const FranciscoSources = [FranciscoJpg, FranciscoWebp];

export const FranklinSingleSources = [FranklinSingleJpg, FranklinSingleWebp];

export const GiovanniSources = [GiovanniJpg, GiovanniWebp];

export const KoliSources = [KoliJpg, KoliWebp];

export const LegendChubbsSources = [LegendChubbsJpg, LegendChubbsWebp];

export const LucySources = [LucyJpg, LucyWebp];

export const MjSources = [MjJpg, MjWebp];

export const OllieSources = [OllieJpg, OllieWebp];

export const PickleSources = [PickleJpg, PickleWebp];

export const PiperSources = [PiperJpg, PiperWebp];

export const RemiSources = [RemiJpg, RemiWebp];

export const RosieSources = [RosieJpg, RosieWebp];

export const SadieSources = [SadieJpg, SadieWebp];

export const SaidiDeanSources = [SaidiDeanJpg, SaidiDeanWebp];

export const SilverRaySources = [SilverRayJpg, SilverRayWebp];

export const ThorSources = [ThorJpg, ThorWebp];

export const TobeySources = [TobeyJpg, TobeyWebp];

export const ValiSources = [ValiJpg, ValiWebp];

export const WinnieSources = [WinnieJpg, WinnieWebp];

export const ZeusSources = [ZeusJpg, ZeusWebp];

export const ZoeSources = [ZoeJpg, ZoeWebp];
